import { Note, NoteType } from '@/@types/note';
import { api } from '@/services/apiClient';
import { useQuery } from '@tanstack/react-query';

import { NoteApiResponse, transformNoteToFrontend } from '../utils/notes.utils';

export type NotesFilters = {
  page?: number;
  perPage?: number;
  search?: string;
  sortBy?: string;
  sort?: 'asc' | 'desc';
  deleted?: boolean;
  type?: NoteType;
  enabled?: boolean;
};

type GetNotesApiResponse = {
  content: NoteApiResponse[];
  total: number;
};

export type GetNotesResponse = {
  notes: Note[];
  totalCount: number;
};

export async function getNotes({
  page,
  perPage,
  search,
  sortBy,
  sort,
  deleted,
  type,
}: NotesFilters): Promise<GetNotesResponse> {
  const { data } = await api.get<GetNotesApiResponse>('/notes', {
    params: {
      page,
      per_page: perPage,
      search,
      sort_by: sortBy,
      sort: sort?.toUpperCase(),
      deleted,
      type,
    },
  });

  return {
    notes: data.content.map(transformNoteToFrontend),
    totalCount: data.total,
  };
}

export function useNotes({
  page = 0,
  perPage = 0,
  search,
  sortBy,
  sort,
  deleted,
  type,
  enabled = true,
}: NotesFilters) {
  return useQuery({
    queryKey: ['notes', { page, perPage, search, sortBy, sort, deleted, type }],
    queryFn: () =>
      getNotes({ page, perPage, search, sortBy, sort, deleted, type }),
    staleTime: 1000 * 60,
    enabled,
  });
}

export function useActiveNotesByType(type: NoteType) {
  return useNotes({
    page: 1,
    perPage: 100,
    sort: 'asc',
    sortBy: 'title',
    deleted: false,
    type,
  });
}
